import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import App from '../../../../spa/pages/[[...route]].jsx'
import '../../css/index.spa.css'

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="*" Component={App} />
    </Routes>
  </BrowserRouter>
)
